/**
 * Credencial de login automático para telas de DESENVOLVIMENTO.
 *
 * ⛔ SEGURANÇA — por que este arquivo existe (revisão de 29/07):
 *
 * Três telas de dev (emulador mobile, teste de API, hook de dados mobile) faziam
 * login automático com a credencial de um usuário ADMIN **escrita no código**. Como
 * o Vite empacota tudo num bundle servido publicamente, a credencial de um usuário
 * ADMIN estava legível em
 * `https://logmed.hyperfocus.com.br/assets/index-*.js` — confirmado por download
 * do arquivo no ar. Qualquer pessoa na internet podia ler.
 *
 * Agora a credencial vem de variável de ambiente do Vite. Em build de produção
 * essas variáveis não são definidas, então:
 *   - nada é embutido no bundle (o `import.meta.env` não resolvido vira undefined);
 *   - o login automático simplesmente não acontece, em vez de falhar com erro.
 *
 * Para usar em desenvolvimento, crie `frontend/.env.local` (já ignorado pelo git):
 *   VITE_DEV_LOGIN_EMAIL=seu@email.com
 *   VITE_DEV_LOGIN_PASSWORD=sua-senha-de-dev
 *
 * NUNCA colocar valor real em `.env.example` nem em código — o `.example` é
 * versionado.
 */

export interface DevLoginCredentials {
  email: string;
  password: string;
}

/**
 * Credencial de dev, ou `null` quando não configurada.
 *
 * Retornar `null` (em vez de lançar) é deliberado: as telas que usam isto são de
 * conveniência, e em produção o esperado é elas simplesmente não autologarem.
 */
export function getDevLoginCredentials(): DevLoginCredentials | null {
  const email = import.meta.env.VITE_DEV_LOGIN_EMAIL as string | undefined;
  const password = import.meta.env.VITE_DEV_LOGIN_PASSWORD as string | undefined;

  if (!email || !password) return null;
  return { email, password };
}
